export const scrollToForm = () => {
  // Robustly scroll the viewport to the top so modals/forms appear at page top.
  // Call multiple ways and twice to handle browsers/containers that may resist a single call.
  try {
    window.requestAnimationFrame(() => {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
    // Fallback immediate
    setTimeout(() => {
      try { document.documentElement.scrollTop = 0; } catch (e) {}
      try { document.body.scrollTop = 0; } catch (e) {}
      try { window.scrollTo(0, 0); } catch (e) {}
    }, 100);

    // If a modal element exists, focus its first focusable element to bring it into view
    setTimeout(() => {
      const modal = document.querySelector('.admin-modal-content');
      if (modal) {
        const focusable = modal.querySelector('input, button, textarea, select, [tabindex]');
        if (focusable && typeof focusable.focus === 'function') focusable.focus();
      }
    }, 200);
  } catch (err) {
    // no-op
  }
};